import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-5 pr-8 pb-4 text-left mt-[-0.875rem]" }
const _hoisted_2 = { class: "flex-col justify-end items-start inline-flex" }
const _hoisted_3 = { class: "self-stretch justify-start items-baseline inline-flex flex-col md:flex-row md:gap-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-base-bold text-racq-error-red text-xl2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-base-bold text-racq-dark-grey text-xl2"
}
const _hoisted_6 = { class: "text-xs text-racq-dark-grey" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-racq-dark-grey"
}
const _hoisted_8 = { class: "line-through" }
const _hoisted_9 = {
  key: 0,
  class: "mt-1 flex"
}

import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import RadioCardListItem from './RadioCardListItem.vue';
import { toCurrency } from '@/utils/convert';
import Tag from '@/components/Tag/Tag.vue';
import { TagTypes } from '@/enums/tag-enums';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardListComparisonItem',
  props: {
    label: {},
    help: {},
    image: {},
    isSelected: { type: Boolean },
    rightLabel: {},
    rightHelp: {},
    hideCheckbox: { type: Boolean },
    amount: {},
    discountedAmount: {},
    tagText: {},
    amountSymbol: {},
    isSticky: { type: Boolean },
    prorataSymbol: {},
    frequencyLabel: { default: 'Per year' },
    marginLeftForAmountSymbol: { type: Boolean },
    removeSpaceAfterProRataSymbol: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const formattedAmount = computed(() => {
  if (props.prorataSymbol) {
    const space = props.removeSpaceAfterProRataSymbol ? '' : ' ';
    return `${props.prorataSymbol}${space}${toCurrency(props.amount)}`;
  }
  return toCurrency(props.amount);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RadioCardListItem, {
    label: _ctx.label,
    help: _ctx.help,
    image: _ctx.image,
    isSelected: _ctx.isSelected,
    rightLabel: _ctx.rightLabel,
    rightHelp: _ctx.rightHelp,
    hideCheckbox: _ctx.hideCheckbox,
    isMega: true,
    isComparison: true,
    isSticky: _ctx.isSticky
  }, {
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.discountedAmount !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_unref(toCurrency)(_ctx.discountedAmount)) + " ", 1),
                  (_ctx.amountSymbol)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'ml-1': _ctx.marginLeftForAmountSymbol })
                      }, [
                        _createElementVNode("sup", null, _toDisplayString(_ctx.amountSymbol), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(formattedAmount.value) + " ", 1),
                  (_ctx.amountSymbol)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ 'ml-1': _ctx.marginLeftForAmountSymbol })
                      }, [
                        _createElementVNode("sup", null, _toDisplayString(_ctx.amountSymbol), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.frequencyLabel), 1)
          ]),
          (_ctx.discountedAmount !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createTextVNode(" Was ")),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(toCurrency)(_ctx.amount)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.tagText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(Tag, {
                tagType: _unref(TagTypes).discount,
                tagText: _ctx.tagText
              }, null, 8, ["tagType", "tagText"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["label", "help", "image", "isSelected", "rightLabel", "rightHelp", "hideCheckbox", "isSticky"]))
}
}

})